import { TypographyMuted } from '@talentmesh/ui/components/typography';
import { siteUrls } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';

function ContactSupportSection() {
    return (
        <div className="flex flex-col items-start gap-4">
            <TypographyMuted>{UIStrings.ContactSupportSection}</TypographyMuted>
            <a
                href={siteUrls.contactSupportUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-sm font-medium no-underline hover:underline"
            >
                {UIStrings.ContactSupport}
            </a>
        </div>
    );
}

export default ContactSupportSection;
